import { FormControl, MenuItem, Stack, TextField } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Durations } from '../../constants';

import FieldLabel from './FieldLabel';

function DurationField({ label, tooltip, control, name, unitName, rules }) {
  const { t } = useTranslation();

  return (
    <Stack spacing={1}>
      <FieldLabel label={label} tooltip={tooltip} />
      <Stack direction="row" spacing={1}>
        <Controller
          name={name}
          control={control}
          rules={{
            min: {
              value: 0,
              message: t('common.validation.min', { value: 0 }),
            },
            ...rules,
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              placeholder={label}
              error={!!error}
              helperText={error ? error.message : null}
              type="number"
              sx={{ flex: 1, flexShrink: 1 }}
              {...field}
            />
          )}
        />
        <Controller
          name={unitName}
          control={control}
          render={({ field }) => (
            <FormControl>
              <TextField select sx={{ minWidth: '150px' }} {...field}>
                {Object.values(Durations).map((i) => (
                  <MenuItem key={i} value={i}>
                    {t(`common.durations.${i}`)}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          )}
        />
      </Stack>
    </Stack>
  );
}

export default DurationField;
